/* TAB 4 — EXPORT (từ RAM đã tải từ máy chủ)
   File PICK / OUT / Đơn cần chú ý: cột y hệt v4 và fixtures/Export_*.xlsx. */
import * as XLSX from 'xlsx';
import * as K from '../core/index.js';
import { S, itemView, statOf, totalCounts } from '../store.js';
import { $, esc, fmt, log, kvSet, kvGet, todayISO, dayOf, vnTime } from '../lib/ui.js';
import { widths, fname, saveBook } from '../lib/xlsx.js';

export function initTab4() {
  $('#exDate').addEventListener('change', exRefresh);
  $('#exBtnPick').onclick = () => {
    const rows = pickAOA();
    if (rows.length < 2) { log('Không có đơn nào pick trong ngày ' + exDay() + ' để xuất.', 'wr'); return; }
    const ws = XLSX.utils.aoa_to_sheet(rows); ws['!cols'] = widths(rows);
    const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    saveBook(wb, fname('PICK'));
  };
  $('#exBtnOut').onclick = () => {
    const rows = outAOA();
    if (!rows[1][5]) { log('Không có đơn nào bàn giao trong ngày ' + exDay() + ' để xuất.', 'wr'); return; }
    kvSet('nguoiGiao', rows[1][2]);
    const ws = XLSX.utils.aoa_to_sheet(rows); ws['!cols'] = widths(rows);
    const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'sheet1');
    saveBook(wb, fname('OUT'));
  };
  $('#exBtnAttn').onclick = () => {
    const sh = attnSheets(), wb = XLSX.utils.book_new();
    sh.forEach((x) => {
      const rows = x.rows.length > 1 ? x.rows : x.rows.concat([['(không có)']]);
      const ws = XLSX.utils.aoa_to_sheet(rows); ws['!cols'] = widths(rows);
      XLSX.utils.book_append_sheet(wb, ws, x.name.slice(0, 31));
    });
    saveBook(wb, fname('DON-CAN-CHU-Y'));
  };
  kvGet('nguoiGiao').then((ng) => { if (ng) $('#exNguoiGiao').value = ng; }).catch(() => { });
}

export function exEnter() {
  const ready = Object.keys(S.orders).length > 0 || Object.keys(S.counts).length > 0;
  $('#exEmpty').style.display = ready ? 'none' : '';
  $('#exMain').style.display = ready ? '' : 'none';
  if (ready) exRefresh();
}

/* đơn còn đáng quan tâm: chưa xong trên sàn, hoặc đã có thao tác trong kho */
function conCan(o) {
  if (o.statusGroup === 'CAN_GIAO' || o.statusGroup === 'MOI') return true;
  return o.pickState === 'done' || o.outState === 'done';
}
export function exScan() {
  const r = {
    total: 0, canGiao: 0, picked: 0, out: 0, pickedNotOut: 0, short: 0, over: 0, sub: 0,
    chuaXuLy: [], thieu: [], du: [], thay: [], chuaOut: [], donMoi: [], batThuong: [],
    chan: { SHOPEE: { t: 0, p: 0, o: 0 }, TIKTOK: { t: 0, p: 0, o: 0 } }
  };
  Object.keys(S.orders).forEach((k) => {
    const o = S.orders[k];
    r.total++; r.chan[o.channel].t++;
    if (o.statusGroup === 'CAN_GIAO') r.canGiao++;
    if (o.statusGroup === 'MOI') r.donMoi.push(k);
    const st = statOf(o);
    if (o.pickState === 'done') {
      r.picked++; r.chan[o.channel].p++;
      if (st.short) { r.short++; r.thieu.push(k); }
      if (st.over) { r.over++; r.du.push(k); }
      if (st.sub) { r.sub++; r.thay.push(k); }
      if (o.outState === 'done') { r.out++; r.chan[o.channel].o++; }
      else { r.pickedNotOut++; r.chuaOut.push(k); }
      if (o.statusGroup === 'HUY' || o.statusGroup === 'XONG')
        r.batThuong.push({ loai: 'Đã xử lý dù trạng thái ' + K.GROUPS[o.statusGroup], key: k });
      if (o.isReturn) r.batThuong.push({ loai: 'Đơn có yêu cầu trả hàng/hoàn tiền', key: k });
    } else {
      if (o.statusGroup === 'CAN_GIAO') r.chuaXuLy.push(k);
      // v4 không có ca này; DB cũ migrate có thể có: out mà chưa pick
      if (o.outState === 'done') { r.out++; r.chan[o.channel].o++; r.batThuong.push({ loai: 'Đã bàn giao nhưng chưa pick', key: k }); }
    }
    if (conCan(o)) (o.items || []).forEach((it) => {
      if (!it.isSub && !it.barcode) r.batThuong.push({ loai: 'Sàn không gắn mã vạch', key: k, ct: it.name });
    });
  });
  return r;
}

export function exRefresh() {
  const r = exScan(); S.ex = r;
  const tc = totalCounts();
  $('#exSess').textContent = 'máy chủ · ' + fmt(tc.total) + ' đơn';
  $('#exStats').innerHTML = [
    ['Đang xử lý', fmt(r.total), '', 'tải về máy'],
    ['Cần giao', fmt(r.canGiao), 'info', ''],
    ['Đã nhặt', fmt(r.picked), 'ok', ''],
    ['Đã bàn giao', fmt(r.out), 'ok', ''],
    ['Nhặt chưa giao', fmt(r.pickedNotOut), r.pickedNotOut ? 'warn' : '', ''],
    ['Đơn lệch', fmt(r.short + r.sub + r.over), (r.short + r.sub + r.over) ? 'warn' : '', 'thiếu/dư/thay thế']
  ].map((x) => '<div class="stat"><div class="k">' + x[0] + '</div><div class="v ' + x[2] + '">' + x[1] + '</div><div class="s">' + x[3] + '</div></div>').join('');

  const rows = ['<tr><th>Kênh</th><th>Đang xử lý</th><th>Đã nhặt</th><th>Đã bàn giao</th></tr>'];
  ['SHOPEE', 'TIKTOK'].forEach((c) => {
    if (!r.chan[c].t) return;
    rows.push('<tr><td><span class="chan ' + c + '">' + c + '</span></td><td class="n">' + fmt(r.chan[c].t) + '</td><td class="n">' + fmt(r.chan[c].p) + '</td><td class="n">' + fmt(r.chan[c].o) + '</td></tr>');
  });
  $('#exTable').innerHTML = rows.join('');

  const day = exDay(), dvn = day.split('-').reverse().join('/');
  const pk = pickAOA(), nPk = pk.slice(1).filter((x) => x[0]).length;
  const nOt = (outAOA()[1][5] || '').split(',').filter(Boolean).length;
  $('#exCntPick').textContent = nPk + ' đơn pick ngày ' + dvn + ' · ' + (pk.length - 1) + ' dòng';
  $('#exCntOut').textContent = nOt + ' đơn bàn giao ngày ' + dvn;
  const sh = attnSheets();
  $('#exCntAttn').textContent = sh.reduce((a, x) => a + x.rows.length - 1, 0) + ' dòng · ' + sh.length + ' sheet';
  $('#exAttnPrev').innerHTML = sh.map((x) => {
    const n = x.rows.length - 1;
    return '<div class="note ' + (n ? 'w' : 's') + '" style="margin-bottom:7px"><span class="ic">' + (n ? '!' : '✓') + '</span><div><b>' + esc(x.name) + '</b> — ' + (n ? n + ' dòng' : 'không có') + '</div></div>';
  }).join('');
}

/* --- dựng dữ liệu xuất --- */
function exDay() {
  let v = $('#exDate').value;
  if (!v) { v = todayISO(); $('#exDate').value = v; }
  return v;
}
function pickedKeysOn(day) {
  return Object.keys(S.orders)
    .filter((k) => S.orders[k].pickState === 'done' && dayOf(S.orders[k].pickedAt) === day)
    .sort((a, b) => (S.orders[a].pickedAt || '').localeCompare(S.orders[b].pickedAt || ''));
}
export function pickAOA() {
  const day = exDay();
  const rows = [['Tài liệu gốc', 'Hoạt động/Mã vạch', 'Hoạt động/Sản phẩm', 'Hoạt động/Hoàn thành']];
  pickedKeysOn(day).forEach((k) => {
    const o = S.orders[k]; let first = true;
    (o.items || []).forEach((raw) => {
      const it = itemView(raw);
      rows.push([first ? o.orderId : '', it.barcode || '', it.name || '', it.picked]);
      first = false;
    });
  });
  return rows;
}
export function outAOA() {
  const day = exDay();
  const ten = 'Đơn gõ ' + day.replace(/-/g, '');
  const ids = Object.keys(S.orders)
    .filter((k) => S.orders[k].outState === 'done' && dayOf(S.orders[k].outAt) === day)
    .sort((a, b) => (S.orders[a].outAt || '').localeCompare(S.orders[b].outAt || ''))
    .map((k) => S.orders[k].orderId);
  return [['Tên', 'Kiểu giao nhận', 'Người giao', 'Shipper', 'Phương tiện vận chuyển', 'Danh sách đơn hàng'],
    [ten, 'Kho Chính: Giao hàng cho shipper', K.norm($('#exNguoiGiao').value) || '', 'Khách đến lấy', 'Xe máy', ids.join(',')]];
}
export function attnSheets() {
  const r = S.ex || exScan();
  const hd = (k) => { const o = S.orders[k]; return [o.orderId, o.channel, o.tracking || '', o.carrier || '']; };
  const sh = [];

  const a = [['Mã đơn hàng', 'Kênh', 'Mã vận đơn', 'Đơn vị vận chuyển', 'Trạng thái sàn', 'Số dòng SP', 'Tổng SL', 'Ngày đặt']];
  r.chuaXuLy.forEach((k) => { const o = S.orders[k]; let q = 0; o.items.forEach((i) => { if (!i.isSub) q += i.qty; }); a.push(hd(k).concat([o.statusRaw, o.items.length, q, o.orderDate || ''])); });
  sh.push({ name: '1. Chưa xử lý', rows: a });

  const b = [['Mã đơn hàng', 'Kênh', 'Mã vận đơn', 'Mã vạch', 'Sản phẩm', 'SL đơn', 'Đã nhặt', 'Thiếu']];
  r.thieu.forEach((k) => { const o = S.orders[k]; o.items.forEach((raw) => { const it = itemView(raw); if (!it.isSub && it.picked < it.qty) b.push([o.orderId, o.channel, o.tracking || '', it.barcode, it.name, it.qty, it.picked, it.qty - it.picked]); }); });
  sh.push({ name: '2. Thiếu hàng', rows: b });

  const c = [['Mã đơn hàng', 'Kênh', 'Mã vận đơn', 'Mã vạch', 'Sản phẩm', 'SL đơn', 'Đã nhặt', 'Dư']];
  r.du.forEach((k) => { const o = S.orders[k]; o.items.forEach((raw) => { const it = itemView(raw); if (!it.isSub && it.picked > it.qty) c.push([o.orderId, o.channel, o.tracking || '', it.barcode, it.name, it.qty, it.picked, it.picked - it.qty]); }); });
  sh.push({ name: '3. Nhặt dư', rows: c });

  const e = [['Mã đơn hàng', 'Kênh', 'Mã vận đơn', 'Mã vạch thay thế', 'Tên nhập tay', 'SL đã nhặt']];
  r.thay.forEach((k) => { const o = S.orders[k]; o.items.forEach((raw) => { const it = itemView(raw); if (it.isSub) e.push([o.orderId, o.channel, o.tracking || '', it.barcode, it.name, it.picked]); }); });
  sh.push({ name: '4. Thay thế SP', rows: e });

  const f = [['Mã đơn hàng', 'Kênh', 'Mã vận đơn', 'Đơn vị vận chuyển', 'Giờ nhặt', 'Máy nhặt', 'Ghi chú']];
  r.chuaOut.forEach((k) => { const o = S.orders[k]; f.push(hd(k).concat([vnTime(o.pickedAt), o.pickedMay || '', o.note || ''])); });
  sh.push({ name: '5. Nhặt chưa bàn giao', rows: f });

  const g = [['Mã đơn hàng', 'Kênh', 'Trạng thái sàn', 'Số dòng SP', 'Ngày đặt']];
  r.donMoi.forEach((k) => { const o = S.orders[k]; g.push([o.orderId, o.channel, o.statusRaw, o.items.length, o.orderDate || '']); });
  sh.push({ name: '6. Đơn mới chưa có MVĐ', rows: g });

  const h = [['Loại bất thường', 'Mã đơn hàng', 'Kênh', 'Chi tiết']];
  r.batThuong.forEach((x) => { const o = S.orders[x.key]; h.push([x.loai, o ? o.orderId : String(x.key).split('|')[1], o ? o.channel : String(x.key).split('|')[0], x.ct || '']); });
  sh.push({ name: '7. Bất thường', rows: h });
  return sh;
}
